module.exports = __webpack_public_path__ + "img/eicheln.1bd531da.png";